import { render } from "./PageThankYou.vue?vue&type=template&id=2ce66cb0&scoped=true"
import script from "./PageThankYou.vue?vue&type=script&lang=js"
export * from "./PageThankYou.vue?vue&type=script&lang=js"

import "./PageThankYou.vue?vue&type=style&index=0&id=2ce66cb0&lang=scss&scoped=true"

import exportComponent from "/Users/adostos/wame/zealy-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ce66cb0"]])

export default __exports__